/**
=========================================================
* Material Dashboard 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useState } from "react";

// react-router-dom components
import { Link } from "react-router-dom";

// @mui icons
import FacebookIcon from "@mui/icons-material/Facebook";
import GitHubIcon from "@mui/icons-material/GitHub";
import GoogleIcon from "@mui/icons-material/Google";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";

import { Alert } from "@mui/material";
import CircularIndeterminate from "components/CircularIndeterminate";

// Authentication layout components
import BasicLayout from "layouts/authentication/components/BasicLayout";

// Images
// import bgImage from "assets/images/bg-sign-in-basic.jpeg";
// import bgImage from "assets/images/serendipia_dark.jpg";
// import bgImage from "assets/images/serendipia_light.jpg";
// import bgImage from "assets/images/0004.png";
import bgImage from "assets/images/Fasecol_login.png";
import { useForm } from "react-hook-form";
import { AuthAPI } from "api/AuthAPI";
import { useMaterialUIController, setToken, setUser, setLoading } from "context";
import { useLocation, useNavigate } from "react-router-dom";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from 'yup'


function Basic() {
  const [controller, dispatch] = useMaterialUIController();
  const formSchema = yup.object().shape({
    email: yup.string().email('Debe ingresa un email válido').required('El campo es requerido'),
    password: yup.string().required('El campo es requerido'),
  })

  const { handleSubmit, register, formState: { errors }, } = useForm({ resolver: yupResolver(formSchema), });
  const [alert, setAlert] = useState(false);
  const [alertContent, setAlertContent] = useState('');
  const [alertColor, setAlertColor] = useState('info');
  const { loading } = controller;

  let navigate = useNavigate();
  let location = useLocation();

  const handleAlert = (content, color) => {
    setAlertContent(content);
    setAlertColor(color);
    setAlert(true)
  }

  const handleAlertClose = () => setAlert(false);

  const alertComponent = (
    <Alert variant="filled" severity={alertColor} onClose={handleAlertClose} >
      <MDTypography variant="body2" color="white">
        {alertContent}
      </MDTypography>
    </Alert>
  );

  const login = (data) => {
    let from = location.state?.from?.pathname || "/";
    setLoading(dispatch, true);
    AuthAPI.login(data)
      .then(response => {
        localStorage.setItem("accessToken", response.accessToken);
        localStorage.setItem("user", JSON.stringify(response.user));
        setToken(dispatch, response.accessToken);
        setUser(dispatch, response.user);
        navigate(from, { replace: true });
      }).catch(error => {
        if (error.response) {
          handleAlert(error.response.data.message, 'error')
        }
      }).finally(() => {
        setLoading(dispatch, false)
      });
  }

  const onSubmit = (data) => {
    login(data);
  }


  return (
    <BasicLayout image={bgImage}>
      {loading ? <CircularIndeterminate></CircularIndeterminate> :
        <MDBox>
          <MDBox mb={4} px={2}>
            {alert ? alertComponent : <></>}
          </MDBox>

          <MDBox
            mx={2}
            mt={-3}
            p={2}
            mb={1}
            textAlign="center"
          >
            <MDTypography variant="h4" fontWeight="medium" mt={1}>
              Iniciar sesión
            </MDTypography>
            <MDTypography display="block" variant="button" my={1}>
              Ingresa tu correo y contraseña para acceder
            </MDTypography>
          </MDBox>
          <MDBox pt={4} pb={3} px={3}>
            <MDBox component="form" role="form" onSubmit={handleSubmit(onSubmit)}>
              <MDBox mb={2}>
                <MDInput type="email" label="Email" name="email" {...register("email")} fullWidth />
                {errors.email && <MDTypography variant="button" color="error">{errors.email?.message}</MDTypography>}
              </MDBox>
              <MDBox mb={2}>
                <MDInput type="password" label="Contraseña" name="password" autoComplete="on" {...register("password")} fullWidth />
                {errors.password && <MDTypography variant="button" color="error">{errors.password?.message}</MDTypography>}
              </MDBox>
              <MDBox mt={4} mb={1}>
                <MDButton variant="gradient" type="submit" color="info" fullWidth>
                  iniciar sesión
                </MDButton>
              </MDBox>
              <MDBox mt={1} mb={1} textAlign="center">
                <MDTypography variant="button" color="text">
                  <MDTypography
                    component={Link}
                    to="/authentication/reset-password"
                    variant="button"
                    color="info"
                    fontWeight="medium"
                    textGradient
                  >
                    ¿Olvidaste tu contraseña?
                  </MDTypography>
                </MDTypography>
              </MDBox>
              <MDBox mt={1} mb={1} textAlign="center">
                <MDTypography variant="button" color="text">
                  ¿No tienes una cuenta?{" "}
                  <MDTypography
                    component={Link}
                    to="/authentication/sign-up"
                    variant="button"
                    color="info"
                    fontWeight="medium"
                    textGradient
                  >
                    Regístrate
                  </MDTypography>
                </MDTypography>
              </MDBox>
            </MDBox>
          </MDBox>
        </MDBox>
      }
    </BasicLayout>
  );
}

export default Basic;
